module.exports = __webpack_public_path__ + "static/media/ch-box-0-hover.94be1f60.svg";